<template>
    <button class="btn-secondary" :class="sizeClass" :disabled="disabled" @click="handleClick">
        <slot>{{ $t('common.button') }}</slot>
    </button>
</template>

<script setup>
    import { computed, defineProps, defineEmits } from 'vue';

    const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'sm',
        validator: (value) => ['sm', 'md', 'lg'].includes(value)
    }
    });

    const sizeClass = computed(() => `btn-${props.size}`);

    const emits = defineEmits(['click']);

    function handleClick(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        emits('click', event);
    }
</script>

<style scoped>
.btn-secondary {
    padding: var(--padding-btn);
    font-family: var(--font-family-primary);
    font-size: var(--font-size-description);
    line-height: 14px;
    font-weight: var(--font-weight-medium);
    color: var(--color-black);
    background: var(--color-white);
    border-radius: var(--border-radius-md);
    transition-duration: var(--transition-slow);
}

.btn-secondary.btn-md {
    padding: var(--padding-btn-md);
    font-size: var(--font-size-caption);
}

.btn-secondary.btn-lg {
    padding: var(--padding-btn-lg);
    font-size: var(--font-size-body);
}

.btn-secondary:hover {
    background: linear-gradient(0deg, var(--color-black-10), var(--color-black-10)), var(--color-white);
}

.btn-secondary:active {
    background: linear-gradient(0deg, var(--color-black-20), var(--color-black-20)), var(--color-white);
}

.btn-secondary:disabled {
    color: var(--color-white-40);
    background: var(--bg-disabled);
    cursor: not-allowed;
}
</style>
